<template>
  <b-modal
    ref="mhlf_kompack"
    dialog-class="!w-full !max-w-[600px]"
    body-class="!p-0"
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    hide-header
  >
    <div
      class="relative p-[20px]"
    >
      <div>
        <img
          src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
          alt="icon-popup-warning"
          class="w-[100px] h-[100px] mx-auto mb-[20px]"
        >
        <h3 class="text-[24px] text-[#333333] font-semibold text-center">
          Atur Jadwal Libur
        </h3>
      </div>
      <validation-observer
        ref="vo-modal-hari-libur-form"
        #default
      >
        <b-form @submit.prevent="handleSubmit">
          <ReusableInput
            v-model="form.date"
            name="Tanggal"
            label="Tanggal"
            placeholder="Masukkan tanggal"
            rules="required"
          >
            <template #input="{ value, disabled, onInput, onBlur, onFocus, placeholder }">
              <b-form-datepicker
                locale="id-ID"
                :value="value"
                :disabled="disabled"
                :placeholder="placeholder"
                :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }"
                :min="today"
                @input="onInput"
                @blur="onBlur"
                @focus="onFocus"
              />
            </template>
          </ReusableInput>
          <ReusableInput
            v-model="form.memo"
            name="Catatan"
            label="Catatan"
            placeholder="Masukkan catatan"
            rules="required|max:100"
          />
          <div class="flex items-center gap-[8px] mt-[16px]">
            <b-button
              type="button"
              variant="outline-primary"
              block
              @click="hide"
            >
              Batal
            </b-button>
            <b-button
              type="submit"
              :variant="isFieldComplete ? 'primary' : 'secondary'"
              block
              class="!flex items-center justify-center gap-[8px] mt-0"
              :disabled="!isFieldComplete || isPending"
            >
              <b-spinner
                v-if="isPending"
                small
              />
              Simpan
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </div>
  </b-modal>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import { today } from '@/store/helpers'
import { toastError, toastSuccess } from '@/libs/toastification'
import ReusableInput from './Input.vue'

export default {
  name: 'ModalHariLiburForm',
  components: {
    ValidationObserver,
    ReusableInput,
  },
  data() {
    return {
      form: {
        date: '',
        memo: '',
      },
      today,
      index: null,
      mode: 'add',
      isPending: false,
    }
  },
  computed: {
    isFieldComplete() {
      return this.form.date && this.form.memo
    },
  },
  methods: {
    /**
     * Show the modal hari libur form, this function would be called by the parent component to show the modal
     * @param {Object} params - The parameters
     * @param {String} params.mode - The mode
     * @param {Number} params.index - The index
     * @param {Object} params.initialData - The initial data
     */
    show({
      mode,
      index,
      initialData,
    }) {
      this.mode = mode
      if (mode === 'edit') {
        this.form = initialData
        this.index = index
      }
      this.$refs.mhlf_kompack.show()
    },
    hide() {
      this.$refs.mhlf_kompack.hide()
    },
    /**
     * Validate, take user confirmation and submit the data
     */
    handleSubmit() {
      this.$refs['vo-modal-hari-libur-form'].validate().then(valid => {
        if (valid) {
          const mappedForm = {
            date: this.form.date,
            memo: this.form.memo,
            type: 1, // 1= hari libur
          }
          if (this.mode === 'edit') {
            mappedForm.id = this.form.id
            this.mutateUpdateHariLibur(this.form.id, mappedForm)
          } else {
            this.mutateHariLibur(mappedForm)
          }
        } else {
          toastError('Data hari libur tidak valid, silahkan cek kembali')
        }
      })
    },
    /**
     * Reset the form
     */
    resetForm() {
      this.form = {
        date: '',
        memo: '',
      }
      this.$refs['vo-modal-hari-libur-form'].reset()
    },
    /**
     * Mutate the hari libur
     * @param {Object} form - The form
     */
    async mutateHariLibur(form) {
      this.isPending = true
      try {
        await this.$http_new.post('/komship/api/v1/warehouse-operational-times', form)
        toastSuccess('Data hari libur berhasil disimpan')
        this.$emit('success')
        this.hide()
        this.resetForm()
      } catch (error) {
        toastError('Gagal mengubah data hari libur, silahkan refresh untuk coba lagi')
      } finally {
        this.isPending = false
      }
    },
    /**
     * Mutate the update hari libur
     * @param {Number} id - The id
     * @param {Object} data - The data
     */
    async mutateUpdateHariLibur(id, data) {
      this.isPending = true
      try {
        await this.$http_new.put(`/komship/api/v1/warehouse-operational-times/${id}`, data)
        toastSuccess('Data hari libur berhasil diubah')
        this.$emit('success')
        this.hide()
        this.resetForm()
      } catch (error) {
        toastError('Gagal mengubah data hari libur, silahkan refresh untuk coba lagi')
      } finally {
        this.isPending = false
      }
    },
  },
}
</script>
